import { CircularProgress } from '@mui/material';
import React from 'react';
import { StyledLoading } from './Loading.styles';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
import ProgressRing from '@weave-design/progress-ring';
export const Loading = ({ loading, children }) => {
    const { isWeaveTheme } = useConsumeWeaveTheme();
    if (loading) {
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledLoading, { "data-testing-id": 'loading-component' }, isWeaveTheme ? React.createElement(ProgressRing, null) : React.createElement(CircularProgress, null))));
    }
    return React.createElement(React.Fragment, null, children);
};
export default Loading;
